/**
* This file was automatically generated by quicktype.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run command(npm run schemabuild) to regenerate this file.
*/
/**
 * 请求的 Content-Type, 默认值是 application/json
 */
export var ContentType;
(function (ContentType) {
    ContentType["ApplicationJSON"] = "application/json";
    ContentType["ApplicationXWWWFormUrlencoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
/**
 * 请求的方法名
 */
export var Method;
(function (Method) {
    Method["Delete"] = "DELETE";
    Method["Get"] = "GET";
    Method["Post"] = "POST";
    Method["Put"] = "PUT";
})(Method || (Method = {}));
